document.documentElement.classList.remove('no-js');

document.addEventListener('DOMContentLoaded', () => {
  const menuButton = document.querySelector('[data-menu-toggle]');
  const mobileMenu = document.querySelector('#MobileMenu');
  if (menuButton && mobileMenu) {
    menuButton.addEventListener('click', () => {
      const open = menuButton.getAttribute('aria-expanded') === 'true';
      menuButton.setAttribute('aria-expanded', String(!open));
      mobileMenu.hidden = open;
    });
  }

  document.querySelectorAll('[data-gallery]').forEach((gallery) => {
    const tabs = gallery.querySelectorAll('[data-media-target]');
    const panels = gallery.querySelectorAll('[data-media-panel]');
    tabs.forEach((tab) => tab.addEventListener('click', () => {
      const target = tab.dataset.mediaTarget;
      tabs.forEach((item) => {
        const active = item === tab;
        item.classList.toggle('is-active', active);
        item.setAttribute('aria-selected', String(active));
      });
      panels.forEach((panel) => {
        const active = panel.dataset.mediaPanel === target;
        panel.hidden = !active;
        panel.classList.toggle('is-active', active);
        if (!active) panel.querySelectorAll('video').forEach((video) => video.pause());
      });
    }));
  });

  document.querySelectorAll('[data-variant-select]').forEach((select) => {
    select.addEventListener('change', () => {
      const form = select.closest('form');
      const option = select.options[select.selectedIndex];
      const button = form && form.querySelector('[data-add-button]');
      const price = document.querySelector('[data-product-price] .price__current');
      const available = option.dataset.available === 'true';
      if (price) price.textContent = option.dataset.price;
      if (button) {
        button.disabled = !available;
        button.textContent = available ? 'Add to cart' : 'Sold out';
      }
      const url = new URL(window.location.href);
      url.searchParams.set('variant', option.value);
      window.history.replaceState({}, '', url);
    });
  });

  if (!document.body.classList.contains('reduce-motion') && window.matchMedia('(pointer: fine)').matches && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    document.querySelectorAll('.js-tilt').forEach((card) => {
      card.addEventListener('pointermove', (event) => {
        const rect = card.getBoundingClientRect();
        const x = (event.clientX - rect.left) / rect.width - 0.5;
        const y = (event.clientY - rect.top) / rect.height - 0.5;
        card.style.setProperty('--tilt-x', `${(-y * 6).toFixed(2)}deg`);
        card.style.setProperty('--tilt-y', `${(x * 8).toFixed(2)}deg`);
      });
      card.addEventListener('pointerleave', () => {
        card.style.removeProperty('--tilt-x');
        card.style.removeProperty('--tilt-y');
      });
    });
  }
});
